var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sh600519-overview"},[_c('div',{staticClass:"sh600519-overview__img-wrapper"},[_c('img',{staticClass:"sh600519-overview__img",attrs:{"src":_setup.img1}})]),_c('div',{staticClass:"sh600519-overview__img-wrapper"},[_c('img',{staticClass:"sh600519-overview__img",attrs:{"src":_setup.img2}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }